import { defaultDonationCampaigns } from 'types';
import { ClientOnly } from '../../components/general/force-client';
import { Meta } from '../../components/meta/meta';
import { DonateForm } from '../donate';

export default function BBQ2025() {
  return (
    <>
      <Meta title="Beds for Kids BBQ" description="Beds for Kids BBQ" blueTopArch />

      <main className="mt-8 lg:py-8">
        {/* <div className="mx-auto max-w-96 mt-8 items-center">
          <LogoMainLong className="mx-auto" />
        </div> */}
        <section className="px-4 text-blue-500 lg:px-0">
          <h1 className="mx-auto mt-4 max-w-3xl text-center font-operetta text-3xl md:text-5xl">Beds for Kids BBQ</h1>
          <p className="mx-auto mb-4 mt-1 max-w-3xl px-4 text-center font-avenir text-xl leading-6 md:text-2xl md:leading-7">
            Hosted by <br className="md:hidden" />
            Adam Snelling
          </p>
          <p className="mx-auto max-w-3xl px-4 text-center font-avenir text-xl leading-6">
            The mission of Beds for Kids is to provide beds and essential furniture to children and their families in
            need.
          </p>
        </section>
        <section className="mt-8 flex flex-col gap-4 px-4 text-blue-500 lg:px-0">
          <p className="mx-auto max-w-3xl px-4 text-center font-avenir text-xl font-semibold leading-6">
            Saturday, July 26th, 2025
          </p>
        </section>
        <section className="mt-16">
          <h2 className="mx-auto my-4 max-w-3xl text-center font-operetta text-4xl text-blue-500 md:text-5xl">
            donate now!
          </h2>
          <ClientOnly>
            <DonateForm fixedCampaign={defaultDonationCampaigns.adamSnellingBBQ2025} noRecurring />
          </ClientOnly>
        </section>
      </main>
    </>
  );
}
